<span 
  [ngClass]="{'results-selected-item': selected}"
  (mouseover)="toggleHover(true)" (mouseleave)="toggleHover(false)"
  [ngStyle]="{'border-color': item.options.color, 
    'background-color': (isHover) ? 'rgba('+color.r+','+color.g+','+color.b+',0.3)' : 'transparent', 
    'bacopacity' : (isHover) ? 0.3 : 1}"
  >{{item.description}}</span>
